import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { ReplaySubject } from 'rxjs';

import { formatUserName } from 'app/core/utilities/user-util';

import { ClipboardResponseService } from '../services/clipboard-response.service';
import { getInviteText } from '../strings';

import { ModalInviteData } from './ModalInviteData';

@Component({
  selector: 'app-modal-social-invite',
  templateUrl: './modal-social-invite.component.html',
  styleUrls: ['./modal-social-invite.component.scss'],
  standalone: false,
})
export class ModalSocialInviteComponent implements OnDestroy {
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalInviteData,
    public dialogRef: MatDialogRef<ModalSocialInviteComponent>,
    private clipboardService: ClipboardResponseService,
    private toasterService: ToastrService,
    private store: Store,
  ) {}

  public copyLink(): void {
    this.copyToClipboard(this.data.socialURI);
    this.closeDetail();
  }

  public copyInvite(): void {
    const { firstName, lastName, socialURI } = this.data;
    const name = formatUserName({ firstName, lastName });
    const invite = getInviteText(name, socialURI);
    this.copyToClipboard(invite);
    this.closeDetail();
  }

  public closeDetail(): void {
    this.dialogRef.close();
  }

  private copyToClipboard(content: string): void {
    this.clipboardService._clipboardService.copyFromContent(content);
    this.toasterService.success('Copied to clipboard', 'Success');
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
